import styled from 'styled-components';
import { BlackButton } from '../../../baseComponents/button';
import { DialogOverlay as DO, DialogContent } from '../../../baseComponents/dialog';
import { RichTextPartial } from '../../../partials/richText';
import { TypographyStyles, colours, focusOutline, fontWeights, fonts, media, spacing } from '../../../stylings';

export const DialogOverlay = styled(DO)`
  background-color: ${colours.MODAL_BACKGROUND_WITH_OPACITY};
  inset: 0;
  position: fixed;
`;

export const DialogContentWrapper = styled(DialogContent)`
  background-color: ${colours.WHITE};
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow-y: auto;
  padding: ${spacing.XS};
  width: min(85vw, 725px);

  @media ${media.between('md', 'lg')} {
    width: min(60vw, 725px);
  }
  @media ${media.greaterThan('lg')} {
    padding: ${spacing.XXS};
  }
`;

export const Title = styled.h2`
  ${TypographyStyles.Headings.H4MontserratSemiBold}
  color: ${colours.BLACK};
  letter-spacing: -0.5px;
  margin: 0;
  padding-bottom: ${spacing.XXXS};
  @media ${media.greaterThan('lg')} {
    font-size: 24px;
    line-height: 34px;
    padding-bottom: ${spacing.XS};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  @media ${media.greaterThan('lg')} {
    display: grid;
    gap: 18px;
    grid-template-columns: 2fr 3fr;
  }
`;

export const ImageContainer = styled.div`
  overflow: hidden;
  width: 100%;
  @media ${media.greaterThan('lg')} {
    flex: 0 0 40%;
  }
`;

export const GiftImage = styled.img`
  padding-bottom: ${spacing.XS};
`;

export const DetailsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.XXXXS};
  width: 100%;
  @media ${media.greaterThan('lg')} {
    flex: 0 0 60%;
    width: auto;
  }
`;

export const GiftTitle = styled.h3`
  ${TypographyStyles.Headings.H4MontserratSemiBold}
  color: ${colours.BLACK};
  letter-spacing: 0;
  margin: 0;
  padding-bottom: 0;
  padding-top: 0;
  @media ${media.greaterThan('lg')} {
    font-size: 20px;
    line-height: 24px;
  }
`;

export const ColorInfo = styled.p`
  ${TypographyStyles.Body.Small.Regular}
  font-size: 16px;
  letter-spacing: 0;
  line-height: 28px;
  margin: 0;
  padding-bottom: 0;
  padding-top: 0;
  & span {
    ${fontWeights.Medium500}
    font-size: 15px;
  }
  @media ${media.greaterThan('lg')} {
    & span {
      ${fontWeights.Medium500}
      font-size: 16px;
    }
  }
`;

export const PriceContainer = styled.div`
  ${TypographyStyles.Body.Medium.SemiBold}
  display: flex;
  gap: ${spacing.XXXS};
  letter-spacing: 0;
  margin: 0;
  padding-bottom: 0;
  padding-top: 0;
  @media ${media.greaterThan('lg')} {
    font-size: 16px;
    line-height: 28px;
  }
`;

export const OriginalPrice = styled.span`
  color: ${colours.BLACK};
  font-size: 16px;
  text-decoration: line-through;
`;

export const FreeLabel = styled.span`
  color: ${colours.FREE_GIFT_GREEN};
  font-weight: ${fontWeights.Bold700};
  text-transform: uppercase;
`;

export const DescriptionTitle = styled.h4`
  ${fonts.Montserrat}
  ${fontWeights.Bold700}
  font-size: 13px;
  letter-spacing: 0px;
  line-height: 20px;
  margin: 0;
  padding-bottom: 0;
  padding-top: 0;
`;

export const DescriptionContainer = styled.div`
  margin: 0;
  padding: 0;
`;

export const Description = styled(RichTextPartial)`
  ${TypographyStyles.Body.Tiny.Regular}
  letter-spacing: 0;
  line-height: 18px;
  margin: 0;
  padding: 0;

  & > p {
    margin: 0;
    padding: 0;
  }
  @media ${media.greaterThan('lg')} {
    padding-right: ${spacing.S};
  }
`;

export const ConfirmButton = styled(BlackButton)`
  font-size: 14px;
  font-weight: 600;
  margin-left: auto;
  margin-right: auto;
  margin-top: ${spacing.XS};
  min-height: 44px;
  padding: ${spacing.XXS} ${spacing.XS};
  text-transform: uppercase;
  width: 80%;

  &:focus {
    ${focusOutline}
  }

  @media ${media.greaterThan('lg')} {
    width: 35%;
  }
`;
